import DryingBedCard from '@/components/drying-lots/DryingBedCard';
import { useMasterStore } from '@/stores/useMaster.store';
import React from 'react';

const DryingBedsListSection = () => {
  const dryingBeds = useMasterStore(state => state.dryingBeds);

  return (
    <div className="mt-3 grid grid-cols-3 gap-2 md:grid-cols-5">
      {dryingBeds?.map((bed, idx) => (
        <DryingBedCard key={bed?._id} bed={bed} />
      ))}
    </div>
  );
};

export default DryingBedsListSection;
